import { KText } from '@/ui-library/components';
import { Flex } from '@chakra-ui/react';
import { CopyFromFilters } from './CopyFromFilters';

export const CopyJobHeader = ({
  modalConfig = {},
  setFilters,
  filters,
  type,
}) => {
  const {
    modalTitle = 'Copy from another job',
    modalDescription = 'Import your Job Description from another job',
  } = modalConfig;

  return (
    <Flex flexDir="column" p="1.5em 1.5em .25em 1.5em">
      <Flex gap=".5rem">
        <Flex flexDir="column" gap=".5rem">
          <KText size="md-medium" color="secondary-900">
            {modalTitle}
          </KText>
          <KText fontSize="sm" fontWeight="400" color="secondary-700">
            {modalDescription}
          </KText>
        </Flex>
      </Flex>
      <CopyFromFilters setFilters={setFilters} filters={filters} type={type} />
    </Flex>
  );
};
